import {skipToken} from '@reduxjs/toolkit/query';
import {Alert} from 'platform/components';
import {Show} from 'platform/foundation';

import {
  GetConsentTemplateMissingPlaceholdersApiArg,
  useGetConsentTemplateMissingPlaceholdersQuery,
} from '@dms/api/customer';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {getConsentTemplatePlaceholderLabel} from '../utils/getConsentTemplatePlaceholderLabel';

interface ConsentTemplateMissingDataAlertProps extends TestIdProps {
  queryArg: GetConsentTemplateMissingPlaceholdersApiArg | null;
}

/**
 * Warns which template placeholders will render empty for the chosen customer, contract
 * information and contact person. The user may still create the consent (decision Q4).
 * Shows nothing while loading, on error, or when the preview reports no missing data.
 */
export function ConsentTemplateMissingDataAlert(props: ConsentTemplateMissingDataAlertProps) {
  const {currentData} = useGetConsentTemplateMissingPlaceholdersQuery(props.queryArg ?? skipToken);

  const labels = (currentData?.placeholders ?? []).map(getConsentTemplatePlaceholderLabel);

  return (
    <Show when={labels.length > 0}>
      <Alert
        type="inline"
        variant="warning"
        title={i18n.t('entity.gdpr.labels.missingTemplateData')}
        message={labels}
        data-testid={props['data-testid']}
      />
    </Show>
  );
}
